import client from '../base-api';

const serviceURL = '/online-users';

const onlineUsersService = {
    heartbeat() {
        return client.post(`${serviceURL}/heartbeat`);
    },
    getOnlineUsers() {
        return client.get(`${serviceURL}/list`);
    },
}

export default onlineUsersService;